import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router';

export function Footer() {
  return (
    <footer className="bg-primary-dark text-background dark:text-foreground">
      <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img
                className="w-14 shrink-0"
                src="/images/logo-mark.webp"
                alt="Al Takassusi General Limited Company"
              />
              <span className="text-sm leading-snug font-semibold">
                Al Takassusi General
                <br />
                Limited Company
              </span>
            </Link>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2 *:*:transition-colors *:*:hover:text-muted-foreground">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/courses">Courses</Link>
              </li>
              <li>
                <Link to="/instructors">Instructors</Link>
              </li>
              <li>
                <a
                  className="flex items-center gap-1"
                  href="https://www.kfshi.com.sa/en-sa/AboutUs"
                  target="_blank"
                  rel="noreferrer"
                >
                  About{' '}
                  <sup>
                    <ExternalLink className="size-2" />
                  </sup>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">Legal</h3>
            <ul className="space-y-2 *:*:transition-colors *:*:hover:text-muted-foreground">
              <li>
                <a
                  href="https://www.kfshi.com.sa/en-sa/Privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-muted-foreground/50 mt-8 border-t py-8 text-center text-sm">
          <p>
            All rights reserved to Al Takassusi General Limited Company (ITGL)
            &copy; {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
}
